import getBusUserConfig from './getBusUserConfig';

export const SET_USER_BUS_PROVIDER = 'BUS/SET_USER_BUS_PROVIDER';

export default function setUserBusProvider(providerId) {
  return async dispatch => {
    dispatch({
      type: SET_USER_BUS_PROVIDER,
      payload: providerId,
    });

    return await dispatch(getBusUserConfig());
  };
}
